export const ACTION_MODAL_BUTTON_TYPES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
} as const;

export const ACTION_MODAL_LABELS = {
  CANCEL: 'Cancel',
  OK: 'Ok',
} as const;
